<!--
  -- 设备ID冲突提示：在新建升级任务，保存时，如果有设备ID冲突，展示冲突提示弹窗
-->
<template>
  <el-dialog
    title="设备ID冲突提示"
    :visible.sync="innerVisible"
    width="760px"
    append-to-body
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div v-if="list.length" class="conflict-section">
      <div class="conflict-title">{{ displayConfig.title }}</div>
      <div v-if="displayConfig.content.length" class="conflict-tips">
        <div v-for="(item, index) in displayConfig.content" :key="index" class="conflict-tip-item">
          <span>{{ index + 1 }}. </span>
          <span>{{ item }}</span>
        </div>
      </div>
      <el-table
        :data="list"
        max-height="300"
        size="mini"
        border
        :header-cell-style="{ background: '#F5F6F7' }"
      >
        <el-table-column label="设备ID" prop="deviceId" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.deviceId || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="设备UUID" prop="deviceUuid" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.deviceUuid || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="设备名称" prop="deviceName" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.deviceName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="家庭名称" prop="spaceName" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.spaceName || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-empty v-else description="暂无冲突设备" />

    <!-- 操作 -->
    <div slot="footer">
      <el-button size="14" @click="handleClose">取 消</el-button>
      <el-button type="primary" size="14" @click="submitForm">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 只负责按 flag 展示文案，不处理提交参数。新增 flag 时在这里补提示。
const CONFLICT_DISPLAY_CONFIG = {
  1: { // 有未完成任务，确认后覆盖
    title: '以下设备仍有未完成的升级任务。确认后将覆盖原有任务，具体影响如下：',
    content: [
      '历史任务中尚未执行的设备，将自动停止升级。',
      '被覆盖的历史任务状态将变更为 “终止”。'
    ]
  },
  2: { // 未完成任务版本更高，确认后从本次任务剔除
    title: '以下设备未完成的升级任务目标版本比本任务高，无法执行。确认后本任务会自动清除以下设备。'
  },
  3: { // 设备正在升级，确认后从本次任务剔除
    title: '以下设备正在升级，无法创建新任务。'
  }
  // 4: {
  //   title: '对应提示文案'
  // }
}

const DEFAULT_CONFLICT_DISPLAY = {
  title: '以下设备存在升级冲突，确认后本任务会自动清除以下设备。'
}

export default {
  name: "conflictDetailsDialog",
  data() {
    return {
      innerVisible: false,
      list: []
    }
  },
  computed: {
    flag() {
      return Number(this.list[0] && this.list[0].flag)
    },
    displayConfig() {
      const config = CONFLICT_DISPLAY_CONFIG[this.flag] || DEFAULT_CONFLICT_DISPLAY
      return {
        title: config.title,
        content: config.content || []
      }
    }
  },
  methods: {
    open(list = []) {
      this.list = Array.isArray(list) ? list : []
      this.innerVisible = true
    },
    handleClose() {
      this.innerVisible = false
    },
    submitForm() {
      this.innerVisible = false
      this.$emit("confirm")
    }
  }
}
</script>
<style scoped lang="scss">
.conflict-section {
  margin-bottom: 16px;
}

.conflict-title {
  margin-bottom: 8px;
  color: #252525;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}

.conflict-tips {
  margin-bottom: 12px;
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
}

</style>
